<template>
  <v-container class="meus-dados-form">
    <v-expand-transition>
      <v-form ref="form" v-if="user" @submit.prevent>
        <v-row justify="center" class="mt-1">
          <v-col cols="12" class="title">
            Informações pessoais
          </v-col>
          <v-col cols="12" lg="8" class="my-0 py-0">
            Nome
            <v-text-field
              v-model="user.nome"
              type="text"
              solo
              flat
              dense
              placeholder="Digite aqui seu nome"
              class="custom-textfield mt-1"
              :rules="[
                () => $v.user.nome.required || 'Campo obrigatório',
                () => $v.user.nome.minLength || 'Mínimo de 6 caracteres'
              ]"
            ></v-text-field>
          </v-col>
          <v-col cols="12" lg="4" class="my-0 py-0">
            E-mail
            <v-text-field
              v-model="user.email"
              type="email"
              solo
              flat
              dense
              placeholder="Digite aqui seu e-mail"
              class="custom-textfield mt-1"
              :rules="[
                () => $v.user.email.required || 'Campo obrigatório',
                () => $v.user.email.email || 'E-mail inválido'
              ]"
            ></v-text-field>
          </v-col>
          <v-col cols="12" lg="4" class="my-0 py-0">
            CPF
            <v-text-field
              v-model="user.cpf"
              type="text"
              solo
              flat
              dense
              v-mask="'###.###.###-##'"
              placeholder="Digite aqui seu CPF"
              class="custom-textfield mt-1"
              :rules="[
                () => $v.user.cpf.required || 'Campo obrigatório',
                () => $v.user.cpf.minLength || 'CPF inválido',
                v => validaCpf(v) || 'CPF inválido'
              ]"
            ></v-text-field>
          </v-col>
          <v-col cols="12" lg="4" class="my-0 py-0">
            RG
            <v-text-field
              v-model="user.rg"
              type="text"
              solo
              flat
              dense
              placeholder="Digite aqui seu RG"
              class="custom-textfield mt-1"
              :rules="[() => $v.user.rg.minLength || 'RG inválido']"
            ></v-text-field>
          </v-col>
          <v-col cols="12" lg="4" class="my-0 py-0">
            Data de nascimento
            <v-text-field
              v-model="user.dtNascimento"
              type="text"
              v-mask="'##/##/####'"
              solo
              flat
              dense
              placeholder="Digite aqui sua data de nascimento"
              class="custom-textfield mt-1"
              :rules="[
                () => $v.user.dtNascimento.required || 'Campo obrigatório',
                () => $v.user.dtNascimento.validDate || 'Data inválido',
                () => $v.user.dtNascimento.minimal || 'O funcionário tem que ter pelo menos 14 anos'
              ]"
            ></v-text-field>
          </v-col>
          <v-col cols="6" lg="3" class="my-0 py-0">
            Sexo
            <v-select
              v-model="user.sexo"
              solo
              flat
              dense
              placeholder="Digite aqui sua data de nascimento"
              :items="sexos"
              class="custom-textfield mt-1"
              :rules="[() => $v.user.sexo.required || 'Campo obrigatório']"
            ></v-select>
          </v-col>
          <v-col cols="6" lg="3" class="my-0 py-0">
            Solteiro
            <v-select
              v-model="user.estadoCivil"
              solo
              flat
              dense
              placeholder="Digite aqui seu estado civil"
              :items="estadosCivis"
              class="custom-textfield mt-1"
              :rules="[() => $v.user.estadoCivil.required || 'Campo obrigatório']"
            ></v-select>
          </v-col>
          <v-col cols="6" lg="3" class="my-0 py-0">
            Telefone
            <v-text-field
              v-model="user.fone"
              solo
              flat
              dense
              v-mask="['(##) #####-####', '(##) ####-####']"
              placeholder="Digite aqui seu estado civil"
              class="custom-textfield mt-1"
              :rules="[
                () => $v.user.fone.required || 'Campo obrigatório',
                () => $v.user.fone.minLength || 'Campo obrigatório'
              ]"
            ></v-text-field>
          </v-col>
          <v-col cols="6" lg="3" class="my-0 py-0">
            Quantidade de filhos
            <v-text-field v-model="user.filhos" solo flat dense readoy class="custom-textfield mt-1">
              <template #append>
                <v-btn
                  @click="() => (user.filhos < 20 ? user.filhos++ : user.filhos)"
                  class="rounded-lg mr-1 py-3"
                  color="primary"
                  x-small
                  ><v-icon size="16">mdi-plus</v-icon></v-btn
                >
                <v-btn
                  @click="() => (!!user.filhos ? user.filhos-- : user.filhos)"
                  class="rounded-lg py-3"
                  color="primary"
                  x-small
                  ><v-icon size="16">mdi-minus</v-icon></v-btn
                >
              </template>
            </v-text-field>
          </v-col>
        </v-row>
        <v-row v-if="user.funcionario">
          <v-col cols="12" class="title">
            Informações trabalhistas
          </v-col>
          <v-col cols="6" lg="6" class="my-0 py-0">
            CTPS
            <v-text-field
              v-model="user.funcionario.ctps"
              type="text"
              solo
              flat
              dense
              placeholder="Digite aqui a série CTPS"
              class="custom-textfield mt-1"
              :rules="[() => $v.user.funcionario.ctps.maxLength || 'CTPS inválido']"
            ></v-text-field>
          </v-col>
          <v-col cols="6" lg="6" class="my-0 py-0">
            Série CTPS
            <v-text-field
              v-model="user.funcionario.serie_ctps"
              type="text"
              solo
              flat
              dense
              placeholder="Digite aqui a série CTPS"
              class="custom-textfield mt-1"
              :rules="[() => $v.user.funcionario.ctps.maxLength || 'CTPS inválido']"
            ></v-text-field>
          </v-col>
          <v-col cols="6" lg="6" class="my-0 py-0">
            UF CTPS
            <v-autocomplete
              v-model="user.funcionario.uf_ctps"
              :items="estados"
              solo
              flat
              dense
              placeholder="Selecione a UF da sua CTPS"
              class="custom-textfield mt-1"
            ></v-autocomplete>
          </v-col>
          <v-col cols="6" lg="6" class="my-0 py-0">
            PIS/PASEP
            <v-text-field
              v-model="user.funcionario.pis_pasep"
              type="text"
              solo
              flat
              dense
              placeholder="Digite aqui seu PIS/PASEP"
              class="custom-textfield mt-1"
              :rules="[() => $v.user.funcionario.pis_pasep.minLength || 'PIS/PASEP inválido']"
            ></v-text-field>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12" md="12" class="text-right">
            <v-btn
              @click="updateUserData"
              type="submit"
              :loading="loadingUpdate"
              class="mt-5"
              color="primary"
              rounded
              large
            >
              Salvar
            </v-btn>
          </v-col>
        </v-row>
      </v-form>
    </v-expand-transition>
  </v-container>
</template>

<script>
import userService from '@/services/user'
import { formatDate, extractOnlyNumbers } from '@/utils/formatter'
import { validationMixin } from 'vuelidate'
import { required, minLength, email, maxLength } from 'vuelidate/lib/validators'
import { dateRegex, SEXOS, ESTADOS_CIVIS, ESTADOS } from '@/utils/constants'
import validaCpf from '@/utils/validaCpf'
import minimalDate from '../../utils/minimalDate'
import { parse } from 'date-fns'

export default {
  name: 'MeusDadosForm',
  mixins: [validationMixin],
  validations: {
    user: {
      nome: {
        required,
        minLength: minLength(6)
      },
      cpf: {
        required,
        minLength: minLength(14)
      },
      email: {
        required,
        email
      },
      rg: {
        required,
        minLength: minLength(5)
      },
      estadoCivil: {
        required
      },
      fone: {
        required,
        minLength: minLength(14)
      },
      sexo: {
        required
      },
      dtNascimento: {
        required,
        validDate(dtNascimento) {
          if (dtNascimento) {
            const [day, month, year] = dtNascimento.split('/')
            return dateRegex.test(dtNascimento) && new Date(year, month - 1, day) < new Date(Date.now())
          }
          return false
        },
        minimal(dt_nascimento) {
          const dataNascimento = parse(dt_nascimento, 'dd/MM/yyyy', new Date())
          return minimalDate(dataNascimento, 14)
        }
      },
      funcionario: {
        ctps: { maxLength: maxLength(20) },
        serie_ctps: { maxLength: maxLength(10) },
        pis_pasep: { minLength: minLength(14) }
      }
    }
  },
  data() {
    return {
      user: null,
      sexos: SEXOS,
      estadosCivis: ESTADOS_CIVIS,
      estados: ESTADOS,
      loadingUpdate: false
    }
  },
  methods: {
    async getUserData() {
      try {
        this.$showLoading()
        const { data } = await userService.show()
        this.user = { ...data, dtNascimento: new Date(data.dtNascimento).toLocaleDateString('pt-br') }
      } catch (error) {
        console.log(error)
      } finally {
        this.$hideLoading()
      }
    },
    validaCpf(cpf) {
      if (process.env.VUE_APP_ENV === 'DEV') return true
      return validaCpf(cpf)
    },
    async updateUserData() {
      if (this.$refs.form.validate()) {
        try {
          this.loadingUpdate = true
          const params = {
            ...this.user,
            dtNascimento: formatDate(this.user.dtNascimento),
            cpf: extractOnlyNumbers(this.user.cpf),
            fone: extractOnlyNumbers(this.user.fone),
            filhos: this.user.filhos.toString()
          }
          await userService.update(params)
          this.$showSuccessMessage('Dados salvos com sucesso')
        } catch ({ response }) {
          this.$showErrorMessage(response.data.message)
        } finally {
          this.loadingUpdate = false
        }
      }
    }
  },
  mounted() {
    this.getUserData()
  }
}
</script>

<style scoped>
.meus-dados-form .title {
  font-size: 1.2rem;
  color: var(--v-primary-base) !important;
}
</style>
